import React from 'react';

import { Loader } from '.';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getAndSetSellerById, setUserSellers } from 'redux/sellers/actions';
import {IframePage, IPostMessageOptions} from 'types/iframe';
import { mustCatchPostMessage } from 'utils/iframeHelper';
import {withParamsFrame} from "../HOCs";

const Settings: React.FC<IframePage> = ({ params }) => {
    const [loaded, setLoaded] = React.useState(false);

    const dispatch = useAppDispatch();

    const { sellerId, allSellers, currentSellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        allSellers: sellers.allSellers,
        currentSellerId: sellers.currentSeller.info.data?.id
    }))

    React.useEffect(() => {
        const entityTemplate: IPostMessageOptions = {
            entity: "seller",
            action: "untie"
        }
        const messageHandler = function (e: MessageEvent) {
            
            if(e.origin !== "https://lk.market") {
                return;
            }

            if(!e.data.hasOwnProperty("entity")) {
                return;
            }

            if(mustCatchPostMessage(entityTemplate, e.data)) {
                const sellersWithoutDeleted = allSellers.filter((seller) => seller.id !== currentSellerId);
                console.log("Settings. Sellers count:", sellersWithoutDeleted.length)
                dispatch(setUserSellers(
                    [
                        ...sellersWithoutDeleted,
                    ]
                ))
                dispatch(getAndSetSellerById(sellersWithoutDeleted[0].id) as any);
            }
            
        }

        window.addEventListener("message", messageHandler);
        return () => window.removeEventListener("message", messageHandler);
    }, [])

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/${sellerId}/seller/edit/${sellerId}${params}`}
                    title="Settings"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(Settings);
